import classnames from 'classnames';
import { useSpring, animated } from 'react-spring';
import { useMedia } from 'utils/hooks';

import { numberWithCommas } from 'utils/helper';
import { useUserData } from 'models/user';
import { useAuth } from 'models/auth';
import { useModal } from 'models/modal';

import pointIcon from 'images/icons/points.png';

import styles from './index.css';

import { characterData, themeData } from 'data/character';

import type { CharacterType, ThemeType } from 'data/character';

export interface UserScoreProp {
    className?: string;
    pointNum?: number;
    disabled?: boolean;
}

const UserScore: React.FC<UserScoreProp> = ({
    className,
    pointNum = 0,
    disabled = false,
    // characterType = 1,
}) => {
    const { countingNum } = useSpring({
        countingNum: pointNum,
        config: {
            frequency: 0.15,
        },
    });

    const media = useMedia();
    const [{ loginType }] = useAuth();
    const [, { openModal }] = useModal();
    const [{ characterType, activeTheme }] = useUserData();

    return (
        <div
            className={classnames(
                styles.userScore,
                loginType !== 'facebook' && styles.visitor,
                className,
            )}
        >
            {media === 'phone' && activeTheme && characterType && (
                <div
                    className={styles.avatar}
                    onClick={() => {
                        if (loginType === 'facebook') {
                            openModal({
                                type: 'profile',
                            });
                        } else {
                            openModal({
                                type: 'needLogin',
                            });
                        }
                    }}
                    role="presentation"
                >
                    {loginType === 'facebook' && (
                        <img
                            src={
                                activeTheme > 2800
                                    ? themeData[activeTheme].avatar
                                    : characterData[characterType].avatar
                            }
                            alt={`character${characterData[characterType]}.id`}
                        />
                    )}
                </div>
            )}
            <div className={styles.scoreWrapper}>
                <div className={styles.icon}>
                    <img src={pointIcon} alt="icon" />
                </div>

                {loginType !== 'facebook' ? (
                    <div className={styles.point}>---</div>
                ) : (
                    <animated.div className={styles.point}>
                        {countingNum.to((value) => numberWithCommas(Math.floor(value)))}
                    </animated.div>
                )}
            </div>
        </div>
    );
};

export default UserScore;
